//@ts-nocheck

import React from "react";

import * as S from "./CardDocuments.styles"

import { Heading, Paragraph } from "../../atoms/Typography/Typography.component";
import { SpacerBase } from "../../atoms/GridSystem";
import Button from "../../atoms/Button/Button.component";

const CardDocuments = ({ pretitle, title, description, cta, parentColorScheme, withBackground }) => {
  return (
    <S.CardDocuments colorScheme={parentColorScheme} withBackground={withBackground}>
      <Paragraph content={pretitle} typo={'paragraphXS'} withBackground={withBackground} />
      <SpacerBase xs={1} />
      <Heading content={title} typo={'headingMD'} withBackground={withBackground} />
      <SpacerBase xs={2} />
      <Paragraph content={description} typo={'paragraphLG'} withBackground={withBackground} />
      <SpacerBase xs={2} />
      <Button 
        variant={'secondary'}
        iconStart={'download'}
        target="_blank"
        {...cta}
      />
    </S.CardDocuments>
  )
}

export default CardDocuments
